exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-wrapper {\n  position: relative;\n  width: 100%; }\n\n.input-suggestion {\n  width: 100%;\n  padding: 0 30px; }\n\n.left-icon,\n.right-icon {\n  position: absolute;\n  top: 13px;\n  font-size: 14px;\n  color: #061021; }\n\n.left-icon {\n  left: 11px; }\n\n.right-icon {\n  right: 9px;\n  cursor: pointer;\n  color: #6b778c; }\n  .right-icon:hover {\n    color: #061021; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input-suggestion/input-suggestion.component.scss
// module id = 900
// module chunks = 22